import {
  initialState,
  Actions,
  State,
  NEW_SESSION,
  NEW_SESSION_SUCCESS,
  NEW_SESSION_ERROR,
  RESET_NEW_SESSION,
} from "../../types/session/new";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_SESSION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case NEW_SESSION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case NEW_SESSION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_NEW_SESSION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
